/**
 * Tax – Tax settings (VAT, Sales tax, exemptions)
 */

export default {
  taxSettings: {
    taxSettings: "Settings",
    vatReg: "VAT",
    salesTax: "Sales tax",
    salesTaxPer: "Sales tax permits",
    permitBusinessName: "State Registered Business Name",
    nexusEstablished: "Nexus Established",
    salesTaxNexusDate: "Nexus date",
    dueDateEstablished: "Schedule Established from",
    stateAssignedPayment: "Assigned Reporting Schedule",
    reportingScheduleRequired: "Assigned Reporting Schedule is required.",
    selectCountryAndReasonForSchedule:
      "Select country and type of registration to load options",
    selectCountryAndEprTypeForSchedule:
      "Select country and type of registration to load options",
    selectCountryStateEprTypeForSchedule:
      "Select country, state or province, and type of registration to load options",
    salesTaxPerDesc:
      "You may need to obtain a sales tax permit in states where you have economic nexus",
    addSalesTaxPer: "Add sales tax permit",
    calcThresh: "Calculate thresholds for economic nexus for all states",
    noData: "There is no data",
    exemp: "Exemptions",
    myExemp: "My exemptions",
    acceptRT: "Accept real-time customer-based exemptions",
    addExemp: "Add new exemption",
    addExempDoc: "Add new exemption document",
    waivForMP: "Waivers for Marketplace",
    waivForMPDesc:
      "Store marketplace facilitator waiver documents linked to your registrations.",
    addWaiv: "Add new waiver document",
    next: "Next",
    back: "Back",
    warning: "Warning",
    willLose: "You will lose all entered data.",
    state: "State",
    file: "file",
    taxExSert: "Tax exemption certificate",
    validFrom: "Valid from",
    validTill: "Valid till",
    active: "Active",
    chooseFile: "Choose file",
    salesTaxID: "Sales Tax ID",
    certType: "Certificate type",
    cancel: "Cancel",
    certNumber: "Certificate number",
    addFile: "Add file",
    autopilot: "Autopilot",
    autopilotDetails: "Autopilot (details)",
    vatReturnsAndSalesTax: "Here you will find returns settings",
    vatReturnsAllJurisdictions: "All jurisdictions",
    salesTaxPermitFilterAllStates: "All states",
    vatReturnsStatusAll: "All",
    vatReturnsApplyFilters: "Apply filters",
    vatReturnsClearFilters: "Clear filters",
    eprSettings: "EPR Settings",
    eprSettingsSubtitle: "Here you will find EPR settings",
    deleteSalesTaxPermit: "Delete sales tax permit",
    deleteExemption: "Delete exemption",
    deleteWaiver: "Delete waiver",
    salesTaxPermitNoData: "Add a Sales tax permit to see data",
    exemptionNoData: "Add a new exemption to see data",
    waiverNoData: "Add a new waiver to see data",
    countries: "Countries",
    country: "Country",
    stores: "Stores",
    store: "Store",
    autoSubSaved: "Auto-Submit settings have been saved",
    typeOfReport: "Type of report",
    saveAll: "Save all",
    save: "Save",
    prepaymentTypeRequired: "Please select prepayment type",
    editVatModalRegistrationNumber: "Registration number",
    editVatModalTypeOfRegistration: "Type of registration",
    editVatModalStatus: "Status",
    editVatModalStatusNew: "New",
    editVatModalStatusDefault: "(default)",
    editVatModalStatusOptionNew: "New",
    editVatModalStatusOptionActive: "Active",
    editVatModalStatusOptionInactive: "Inactive",
    editVatModalStatusOptionArchived: "Archived",
    editVatModalRegistrationDate: "Registration date",
    editVatModalAssignedReportingPeriodicity: "Assigned reporting periodicity",
    editVatModalFirstReportingPeriod: "First reporting period for assigned periodicity",
    salesTaxPermitStateSpecifics: "State specifics",
    salesTaxPermitPrepaymentPeriodicity: "Prepayment periodicity",
    salesTaxPermitPrepaymentFirstPeriod: "First reporting period for prepayment",
    editVatModalLappaOffDefault: "Off (default)",
    editVatModalCountrySpecifics: "Country specifics",
    editVatModalCountrySpecificsFor: "{{country}}",
    editVatModalLand: "Land",
    editVatModalTypeOfActivity: "Type of activity",
    editVatModalReportViaLtax: "Use this number for reporting via Lappa",
    editVatTableReportViaLappa: "Lappa reporting",
    addReturnsModalTitleVat: "Add a VAT",
    addReturnsModalTitleSalesTax: "Add sales tax",
    addReturnsModalTitleEpr: "Add EPR",
    editReturnsModalTitleVat: "Edit VAT",
    editReturnsModalTitleSalesTax: "Edit Sales tax",
    editReturnsModalTitleEpr: "Edit EPR",
  },
};
